<template>
    <div id="ReportPatientContact">
      <div v-if="this.filterView">
        <MdTitle v-bind:Text="$t('patientContactsRep.RepTitle')" />
        <div class="row">
          <div class="col-sm-12 col-md-12 mb-4">
            <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                <div class="input-group" dir="ltr">
                      <input 
                        type="text" 
                        class="form-control"
                        :dir="dirInput"
                        v-model="parameter.SearchCriteria"   
                          @keyup.enter="SearchContacts"                            
                      >
                      <div class="input-group-append">
                          <div class="input-group-append">
                          <MdButton 
                            v-bind:Name="'btnsearchinput'"
                            v-bind:VariantProp="'btn btn-sm search-attached'"
                            v-bind:IconClass="'mdi mdi-magnify'"
                            v-on:click="SearchContacts">
                          </MdButton>
                      </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
        <b-row>
          <b-col lg="3" md="3" sm="12">         
            <MdSelect
              v-bind:Label="$tc('Shared.Patient',2)"
              v-bind:Options="PatientsList"
              v-bind:Model="PatientCodeModel"
              v-bind:FieldDescription="'patientName'"
              v-bind:FieldCode="'patientcode'"
              v-bind:Multiple="true"             
              :Input="ChangeDropDownPatients"
              :CustomLabel="customLabelPatients"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$t('Contact.ActiveReleaseOnFile')"
              v-bind:Options="ActiveReleaseOnFile"
              v-bind:FieldDescription="'text'"
              v-bind:FieldCode="'value'"
              v-bind:Model="releaseOnFile"  
              v-bind:Multiple="false" 
              :Input="ChangeDropDownFile"
              />
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$t('Contact.MayHavePhoneCalls')"
              v-bind:Options="YesNoOptionsNumericThree"
              v-bind:FieldDescription="'text'"
              v-bind:FieldCode="'value'"
              v-bind:Model="mayHavePhoneCalls"  
              v-bind:Multiple="false" 
              :Input="ChangeDropDownPhoneCalls"
             />
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
                v-bind:Label="$t('Contact.SupervisedPhoneCalls')"
                v-bind:Options="YesNoOptionsNumericThree"
                v-bind:FieldDescription="'text'"
                v-bind:FieldCode="'value'"
                v-bind:Model="supervisedPhoneCalls"                       
                v-bind:Multiple="false"
                :Input="ChangeDropDownSupervisedCalls"
                />
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$t('Contact.VisitationPermission')"
              v-bind:Options="YesNoOptionsNumericTwo"
              v-bind:FieldDescription="'text'"
              v-bind:FieldCode="'value'"
              v-bind:Model="visitationPerm"                       
              v-bind:Multiple="false"
              :Input="ChangeDropDownVisitationPerm"
              />
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$t('Contact.MayVisit')"
              v-bind:Options="YesNoOptionsNumericThree"
              v-bind:FieldDescription="'text'"
              v-bind:FieldCode="'value'"
              v-bind:Model="mayVisit"                       
              v-bind:Multiple="false"
              :Input="ChangeDropDownMayVisit"
              />
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$t('Contact.UnsupervisedVisitsOnGrounds')"
              v-bind:Options="YesNoOptionsNumericThree"
              v-bind:FieldDescription="'text'"
              v-bind:FieldCode="'value'"
              v-bind:Model="unsupVisitsOnGrounds"                       
              v-bind:Multiple="false"
              :Input="ChangeDropDownVisitsOnGrounds"
                />
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$t('Contact.UnsupervisedVisitsOffGrounds')"
              v-bind:Options="YesNoOptionsNumericThree"
              v-bind:FieldDescription="'text'"
              v-bind:FieldCode="'value'"
              v-bind:Model="unsupVisitsOffGrounds"                       
              v-bind:Multiple="false"
              :Input="ChangeDropDownVisitsOffGrounds"
              />
            </b-col>
        </b-row>
        <b-row>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
                v-bind:Label="$t('Contact.NeedProbationForOffGrounds')"
                v-bind:Options="YesNoOptionsNumericThree"
                v-bind:FieldDescription="'text'"
                v-bind:FieldCode="'value'"
                v-bind:Model="needProbApprForOffGrounds"                       
                v-bind:Multiple="false"
                :Input="ChangeDropDownApprForOffGrounds"
                />
          </b-col>
          <b-col lg="3" md="3" sm="12"/>
          <b-col lg="3" md="3" sm="12"/>
          <b-col lg="3" md="3" sm="12">
            <div class="text-md-right mt-3">
                <button 
                    v-on:click="SearchContacts"
                    type="button"
                    class="btn btn-primary btn-login mx-2"												
                    id="btnsearchinput">
                    {{ $t('Shared.Search') }}
                </button>
            </div>
          </b-col>   
        </b-row>

        <div class="row">
          <div class="col-md-12">
              <MdTitle  v-bind:Text="$t('Shared.SearchResult')" 
                        v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
              <div class="row">
                <div class="col-md-12">
                <MdTable 
                  v-bind:fields="fields"
                  v-bind:items="items"
                  v-bind:totalRows="totalRows"
                  v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                  v-bind:currentPage="currentPage"
                  v-bind:perPage="perPage"
                  v-bind:pageOptions="pageOptions"
                  v-bind:refTable="refTable"
                  :pageChanged="pageChanged"
                  :perPageFunction="PerPageFunction">
                </MdTable>
              </div>
            </div>
          </div>
        </div>

        <div class="space-actions"></div>
        <div class="page-actions">
          <MdButton
            v-bind:Label="$t('Shared.Back')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="reportList"
            v-bind:Name="'btn_ReportList'"/>
          <MdButton
            v-bind:Label="$t('Shared.Report')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="onClickShowReport"
            v-bind:Name="'btn_Print'"/>

           <b-dropdown id="dropdown-dropup" dropup :text="$t('Shared.Export')" variant="primary" class="m-2">
						<b-dropdown-item v-on:click="handlePdf('export')">{{$t('Shared.PDF')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handlePdf('email')">{{$t('Shared.PDFByEmail')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('export')">{{$t('Shared.CSV')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('email')">{{$t('Shared.CSVByEmail')}}</b-dropdown-item>
					</b-dropdown>      

        </div>
      </div>
      <DxPopup
        :visible="isReportVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-close-button="true"
        :show-title="true"
        :hide-on-parent-scroll="true"
        :title="$t('patientContactsRep.RepTitle')"
        @hidden="onHiddenReport"
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"
        @showing="onShowing"
      >
        <ReportViewer
          ref="patientContacts"
          :ReportName="'PatientContacts'"
          :ReportTitle="$tc('Contact.PatientContact',2)"
          :IsAnAPIReport="true"
        />
    </DxPopup>

     <CSVExportHelper
      ref="csvExportHelper"
      v-bind:conformSubject="$tc('Contact.PatientContact',2)"
      v-bind:sendEmailAPI="'/Utils/sendEmail'"
      v-bind:exportCsvAPI="'/PatientContacts/exportCSV'"
    >    
    </CSVExportHelper>
  </div>
</template>

<script>
import Vue from 'vue'
import { DxPopup } from 'devextreme-vue/popup';
import ShowMessage from '@/components/messages/ShowMessage.js';
import PatientService from '@/services/patient.service';
import Utils from '@/common/utils';
import EnumService from '@/services/enum.service'
import DBFunctions from '@/common/DBFunctions.js'
import ContactService from '@/services/contact.service';
import { EventBus } from '@/event-bus.js';

export default Vue.extend({
    name: "PatientContactsRep",
    mixins: [ ShowMessage, Utils, DBFunctions ],
    components: { DxPopup },
    props: {
      patientCode: String,
      closeWindow: Function,
      recNo: String,
      patientName: String,
      dob: String,
      filterView: Boolean
    },
    data() {
        return {
          OptionsRightMenu:{
              visible:false,
              ItemsList:[],
              btnvisible:false,
              itemdisabled: false,
              PatientCode:'',
              Mode:this.edit_mode,
              favButtonAtion:false          
            },
            isParamVisible: true,
            isReportVisible: false,
            reportParams: [],
            PatientsList:[],
            params: {
              "PatientCodeList": []
            },
            parameter:{
              Status: true,
            },
            PatientCodeModel:'',
            releaseOnFile:"",
            mayHavePhoneCalls:"",
            supervisedPhoneCalls:"",
            visitationPerm:"",
            mayVisit:"",
            unsupVisitsOnGrounds:"",
            unsupVisitsOffGrounds:"",
            needProbApprForOffGrounds:"",
            ActiveReleaseOnFile: EnumService.YesNoOptions,
            YesNoOptionsNumericThree: EnumService.YesNoOptionsNumericThree,
            YesNoOptionsNumericTwo: EnumService.YesNoOptionsNumericTwo,
            items: [],         
            fields: [
              { key: 'contactname', sortable: true, label: this.$t('ContactsList.ContactName'), class: 'text-rigth' },
              { key: 'dob', sortable: true, label: this.$t('Shared.Dob'), class: 'text-rigth' },
              { key: 'cellPhone', sortable: true, label: this.$t('Shared.CellPhone'), class: 'text-rigth' },
              { key: 'dayPhone', sortable: true, label: this.$t('Shared.DayPhone'), class: 'text-rigth' },
              { key: 'nightPhone', sortable: true, label: this.$t('Shared.NightPhone'), class: 'text-rigth' },              
              { key: 'contactType', sortable: true, label: this.$t('Shared.ContactType'), class: 'text-rigth' },      
              { key: 'email', sortable: true, label: this.$t('Shared.Email'), class: 'text-rigth' },
              { key: 'recordId', sortable: true, label: 'RecorId', class: 'hidden' },
              { key: 'patientName', sortable: true, label: this.$t('Shared.PatientName'), class: 'text-rigth' },
              { key: 'patientCode', sortable: true, label: this.$tc('Shared.PatientCode'), class: 'text-rigth' },
              { key: 'patientDob', sortable: true, label: this.$t('Shared.Dob'), class: 'text-rigth' },
              { key: 'relation', sortable: true, label: this.$t('Shared.Relation'), class: 'text-rigth' },  
              { key: 'releaseOnFileTranslated', sortable: true, label: this.$t('Shared.ReleaseOnFile'), class: 'text-rigth' }, 
              { key: 'visitationPerm', sortable: true, label: this.$t('Contact.VisitationPermission'), class: 'text-rigth' },
              { key: 'mayVisit', sortable: true, label: this.$t('Contact.MayVisit'), class: 'text-rigth' },
              { key: 'unsupVisitsOnGrounds', sortable: true, label: this.$t('Contact.UnsupervisedVisitsOnGrounds'), class: 'text-rigth' },
              { key: 'unsupVisitsOffGrounds', sortable: true, label: this.$t('Contact.UnsupervisedVisitsOffGrounds'), class: 'text-rigth' },
              { key: 'mayHavePhoneCalls', sortable: true, label: this.$t('Contact.MayHavePhoneCalls'), class: 'text-rigth' },
              { key: 'supervisedPhoneCalls', sortable: true, label: this.$t('Contact.SupervisedPhoneCalls'), class: 'text-rigth' },  
              { key: 'needProbApprForOffGrounds', sortable: true, label: this.$t('Contact.NeedProbationForOffGrounds'), class: 'text-rigth' }, 


            ],
            pageOptions: [5, 10, 15 ],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            selected: [],
            Header:{},
            refTable: 'selectableTable', 
            ShowMessageIsEmpty:true,
            SearchCriteria:"",
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
        }
    },
    methods: {

      onShowing(e) {
        let contentElement = e.component.content();
        let titleElement = e.component._$title[0]
        contentElement.style.padding = '0px';
        titleElement.style.padding = '0px 20px'
      },

      onHiddenReport() {
        this.isReportVisible = false
        if(!this.filterView)
          this.closeWindow();
      },

      onClickClose() {
        this.closeWindow()
        this.isParamVisible = false;
      },

      reportList() {
        this.checkExistFavorite('/app/reports/patients');
        this.$router.push({ name: "reportListPatient" }).catch(()=>{});
      },

      initializeParameters() {
        ['PatientCode','recNo','patientName'].forEach(
          key => this.parameter[key] = null
        );

        this.parameter.PatientCodeList = this.params.PatientCodeList && this.params.PatientCodeList !== ''
          ? this.params.PatientCodeList
          : null;
        this.parameter.releaseOnFile = this.releaseOnFile;
        this.parameter.mayHavePhoneCalls = this.mayHavePhoneCalls;
        this.parameter.supervisedPhoneCalls = this.supervisedPhoneCalls;
        this.parameter.visitationPerm = this.visitationPerm;
        this.parameter.unsupVisitsOnGrounds =  this.unsupVisitsOnGrounds;
        this.parameter.unsupVisitsOffGrounds = this.unsupVisitsOffGrounds;
        this.parameter.needProbApprForOffGrounds = this.needProbApprForOffGrounds;
        this.parameter.mayVisit = this.mayVisit;
        this.parameter.SearchCriteria = this.SearchCriteria;
      },

      initializePdfParameters() {
         this.reportParams = []
        this.reportParams.push({ paramName: 'patientCode', paramValue: this.patientCode})
        this.reportParams.push({ paramName: 'recNo', paramValue: this.recNo})
        this.reportParams.push({ paramName: 'patientName', paramValue: this.patientName})
        this.reportParams.push({ paramName: 'patientCodeList',
           paramValue: (this.params.PatientCodeList.length == 0) ? this.patientCode :this.params.PatientCodeList })

        this.reportParams.push({ paramName: 'releaseOnFile', paramValue: this.releaseOnFile})
        this.reportParams.push({ paramName: 'mayHavePhoneCalls', paramValue: this.mayHavePhoneCalls})
        this.reportParams.push({ paramName: 'supervisedPhoneCalls', paramValue: this.supervisedPhoneCalls})
        this.reportParams.push({ paramName: 'visitationPerm', paramValue: this.visitationPerm})
        this.reportParams.push({ paramName: 'mayVisit', paramValue: this.mayVisit})
        this.reportParams.push({ paramName: 'unsupVisitsOnGrounds', paramValue: this.unsupVisitsOnGrounds})
        this.reportParams.push({ paramName: 'unsupVisitsOffGrounds', paramValue: this.unsupVisitsOffGrounds})
        this.reportParams.push({ paramName: 'needProbApprForOffGrounds', paramValue: this.needProbApprForOffGrounds})
        this.reportParams.push({ paramName: 'rSearchCriteria', paramValue: this.SearchCriteria})
      },

      onClickShowReport() {
        this.isParamVisible = false
        this.initializePdfParameters();
        this.isReportVisible = true
        this.$refs.patientContacts.buildDocument(this.reportParams)
      },

      getItemsByComma(values, field) {
        let len = values.length;
        let valuesSeparated = [];
        if (len > 0){
          var i = 0;
          values.forEach(function(e) {   
            if(i < len-1){
              valuesSeparated += e[field]+",";
            }else{
              valuesSeparated += e[field];
            }
            i++;                    
          });
          return valuesSeparated;
        } else {
          return [];
        }
      },

      ChangeDropDownPatients(values) {
        this.params.PatientCodeList = [];
        values.forEach(it => {
          this.params.PatientCodeList.push(it.patientcode)
        });
      },

      customLabelPatients ({ patientName, patientcode }) {
        return `${patientName} – ${patientcode}`
      },
      ChangeDropDownFile(value){
         this.releaseOnFile = value ? value.value : '';
      },
      ChangeDropDownPhoneCalls(value){
         this.mayHavePhoneCalls = value ? value.value : '';
      },
      ChangeDropDownSupervisedCalls(value){
         this.supervisedPhoneCalls = value ? value.value : '';
      },
      ChangeDropDownVisitationPerm(value){
         this.visitationPerm = value ? value.value : '';
      },
      ChangeDropDownMayVisit(value){
         this.mayVisit = value ? value.value : '';
      },
      ChangeDropDownVisitsOnGrounds(value){
         this.unsupVisitsOnGrounds = value ? value.value : '';
      },
      ChangeDropDownVisitsOffGrounds(value){
         this.unsupVisitsOffGrounds = value ? value.value : '';
      },
      ChangeDropDownApprForOffGrounds (value){
         this.needProbApprForOffGrounds = value ? value.value : '';
      },
      getPatients() {              
          PatientService.getAll(this.parameter)
          .then((response) => {
          if(response.status == '200' && response.data && response.data.length > 0){
            this.PatientsList = response.data; 
            this.PatientsList.forEach(function(element) {
                element.patientName = element.firstname + " " + element.lastname;   
              });
            }      
            this.$emit('load', false);
          })
          .catch(error => {
            this.$emit('load', false);
            if (!error.response) {
                // network error
                this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
            } else {
                this.showMessage(this.$tc('Msg.Error'),error,"error");
            }
          });
      },
      SearchContacts(){
        this.Loading = true;
        this.$emit('load', this.Loading);
        this.items = [];
        this.currentPage = 1;
        this.parameter.PageNumber = 1;
        this.totalRows = this.items.length;
        this.getContacts();
      },

      getContacts() {
        this.parameter.PageNumber = this.currentPage;
        this.parameter.PageSize = this.perPage;
        this.initializeParameters();

        ContactService.getAllWithFiltes(this.parameter)
          .then((response) => {
            if(response.status == '200' && response.data && response.data.length > 0){
            this.items = response.data;
            let headerString = response.headers["x-pagination"];
            this.Header = JSON.parse(headerString);
            this.totalRows = this.Header.TotalCount;
            this.items.forEach(item => {
              item.contactname = (item.firstName ? item.firstName:'') + " " + (item.lastName? item.lastName:''); 
              item.patientName = (item.patientFirstName ? item.patientFirstName:'') + " " + (item.patientLastName? item.patientLastName:''); 
              if (item.patientDob)	
                  item.patientDob = Utils.formatterDateToString(item.patientDob);
              if (item.dob)	
                  item.dob = Utils.formatterDateToString(item.dob); 
            });
            }
            if(this.items.length === 0){
              this.ShowMessageIsEmpty = true;
            }
            this.Loading = false;
            this.$emit('load', this.Loading);
          })
          .catch(error => {
            this.Loading = false;
            this.$emit('load', this.Loading);
            this.showResponseErrorMessage(error);
          });
      },
      pageChanged (page) {            
        this.currentPage = page;
        this.getContacts();    
      },

      PerPageFunction(perpage){
        this.perPage = perpage;  
        this.currentPage = 1;
        this.getContacts();
      },
      
      handleCSV(action) {
        this.initializeParameters();
        switch(action) {
          case 'export':
            this.$refs.csvExportHelper.exportCSV(this.parameter);
          break;
          case 'email':
            this.$refs.csvExportHelper.emailCSV(this.parameter);
          break;
          default:
            console.warn('unknow action:', action);
          break;
        }
      },

      handlePdf(action) {
        this.initializePdfParameters();
        switch(action) {
          case 'export':
            this.$refs.csvExportHelper.exportToPdf('PatientContacts', true, false, this.reportParams);
          break;
          case 'email':
            this.$refs.csvExportHelper.emailPdf('PatientContacts', true, false, this.reportParams);
          break;
          default:
            console.warn('unknow action:', action);
          break;
        }
      },
    },
    created() {
      if(this.filterView)
        this.getPatients();
    },
    mounted () {
      if(!this.filterView)
        // this.isReportVisible = true
        this.onClickShowReport();

      this.OptionsRightMenu.ItemsList = [];
      let layoutStatus = this.$store.state.layoutStatus;
      switch(layoutStatus) {
        case 'L0R1':
          this.OptionsRightMenu.favButtonAtion = false;
          this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
        case 'L1R0':
        case 'L1R1':
            this.OptionsRightMenu.btnvisible = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
        default:
            this.OptionsRightMenu.favButtonAtion = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
      }

      EventBus.$on("ShowWeel", function (isShow) { 
        isShow ? this.$emit('load', true) : this.$emit('load', false);     
      }.bind(this));
    },

  })
</script>
<style>
  .dxrd-report-preview-holder {  
      height: 94% !important; 
  } 
</style>
